import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-finalize-dialog',
  templateUrl: './finalizeDialog.component.html',
  styleUrls: ['./finalizeDialog.component.scss']
})
export class FinalizeDialogComponent {
  passwordControl = new FormControl('', [Validators.required]);
  hidePassword = true;
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<FinalizeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onConfirm(): void {
    if (this.passwordControl.valid) {
      this.dialogRef.close({
        action: 'confirm',
        password: this.passwordControl.value
      });
    }
  }
}

